// task.js

export class Task {
    constructor(executor) {

        // ensure executor is a function
        if (typeof executor !== "function") {
            throw new Error("Task requires an executor function.")
        }

        // private variables
        this._runable = true
        this._executor = executor
        this._promise = null
        this._progressCallback = null
        this._finishCallback = null
        this._errorCallback = null
    }

    isRunable() {
        return this._runable
    }

    run(app, card) {
        if (this._promise) return this

        this._promise = new Promise((resolve, reject) => {
            try {
                const execution = this._executor(
                    ({ assets, stage }) => {
                        this._runable = false
                        resolve({ assets, stage })
                    },
                    (error) => {
                        reject(error)
                    },
                    (message, stage, assets) => {
                        if (this._progressCallback) this._progressCallback(message, stage, assets)
                    },
                    app,
                    card
                )
                Promise.resolve(execution).catch(reject)
            } catch (error) {
                reject(error)
            }
        })

        this._promise.then(
            ({ assets, stage }) => {
                if (this._finishCallback) this._finishCallback(assets, stage)
            },
            error => {
                this._runable = false
                if (this._errorCallback) this._errorCallback(error)
            }
        ).catch(() => {})

        return this
    }

    finished() {
        return this._promise
    }

    onProgress(callback) {
        this._progressCallback = callback
        return this
    }

    onFinish(callback) {
        this._finishCallback = callback
        return this
    }

    onError(callback) {
        this._errorCallback = callback
        return this
    }
}
